module.exports = __webpack_public_path__ + "static/media/1POLICY6.454f6f50.jpg";